import { render, staticRenderFns } from "./RankStamp.vue?vue&type=template&id=6971873b&"
import script from "../../models/analysis/rank-stamp.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/rank-stamp.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports